// extracted by mini-css-extract-plugin
module.exports = {"contentWidthFull":"1024px","contentWidthMedium":"800px","contentWidthSmall":"600px","tooltipWidthMedium":"300px","tooltipWidthLarge":"500px"};